import Box from '@mui/material/Box';
import React from 'react';

import { MagnitudeBarProps } from './MagnitudeBar.props';

/**
 * A proportional-width bar used as a scanning cue beside a number.
 *
 * Deliberately `aria-hidden`: the count sits next to it and is the accessible
 * carrier. It is not a `progressbar` either — these are relative magnitudes,
 * not progress toward a goal, and `progressbar` would make screen readers
 * announce a percentage that means nothing here.
 */
export const MagnitudeBar: React.FC<MagnitudeBarProps> = ({
  value,
  fillColor,
  trackColor,
  height = 4,
  testDataId,
}) => {
  const safe = Number.isFinite(value) ? Math.min(1, Math.max(0, value)) : 0;

  return (
    <Box
      aria-hidden
      data-testid={testDataId}
      sx={{
        height,
        width: '100%',
        borderRadius: `${height}px`,
        bgcolor: trackColor,
        overflow: 'hidden',
      }}
    >
      <Box
        data-testid={testDataId ? `${testDataId}-fill` : undefined}
        sx={{
          height: '100%',
          width: `${safe * 100}%`,
          borderRadius: `${height}px`,
          bgcolor: fillColor,
          transition: 'width 320ms ease',
          '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
        }}
      />
    </Box>
  );
};
